<div id="coordinator-view" class="page-layout blank">

    <div class="content">

        <div class="left">

            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">

                <!-- Widget Companies  -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="37">
                    <app-coordinator-company></app-coordinator-company>
                </div>
                <!-- / Widget Companies -->

                <!-- Widget Doctors -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="37">
                    <app-coordinator-doctor></app-coordinator-doctor>
                </div>
                <!-- / Widget Doctors -->

                <!-- Widget  Company Statistics --> 
                <div class="widget" fxFlex="100" fxFlex.gt-sm="26">
                    <app-coordinator-statistics></app-coordinator-statistics>
                </div>
                <!-- / Widget  Company Statistics -->

            </div>

        </div>
    </div>
</div>